module.exports = __webpack_public_path__ + "static/media/laundary.e4799d8b.png";